import {
  CinematicScreenSize,
  CinematicScreenType,
  CinematicTypeEnum,
  SpriteDirection,
} from "game-engine/types";

import { CinematicId } from "game-files/common/ids";
import GAME_CONFIG from "game-files/gameConfig";
import MUSIC_CONFIGS from "game-files/audio/MUSIC_CONFIGS";
import SOUND_CONFIGS from "game-files/audio/SOUND_CONFIGS";
import TestBackgroundSky02_Background from "./assets/test-background-sky-02.jpg";
import TestBackgroundSky02_BirdSprite from "./assets/test-background-sky-02-bird-sprite.png";
import TestBackgroundSky02_Cloud_01 from "./assets/test-background-sky-02-cloud-01.png";
import TestBackgroundSky02_Cloud_02 from "./assets/test-background-sky-02-cloud-02.png";
import TestBackgroundSky02_StarsSprite from "./assets/test-background-sky-02-stars-sprite.png";
import TestBackgroundSky02_Video from "./assets/test-background-sky-02-video.mp4";

const TestCinematicScreen06: CinematicScreenType = {
  id: CinematicId.TestCinematicScreen06,
  type: CinematicTypeEnum.screen,
  size: CinematicScreenSize.scene,
  hideGui: true,

  fadeIn: true,
  fadeOut: true,

  audio: {
    music: {
      musicConfigId: MUSIC_CONFIGS.Test_01.id,
      volume: undefined,
    },
    sound: {
      soundConfigId: SOUND_CONFIGS.Test_Bird.id,
      volume: undefined,
      loop: undefined,
    },
  },

  background: {
    color: "red",

    position: { x: 0, y: 0 },

    imageComposition: {
      layers: [
        {
          image: {
            src: TestBackgroundSky02_Background,
            width: 320,
            height: 250, // necessary for background transforms, otherwise the image is clipped to scene size
          },
        },
        {
          image: { src: TestBackgroundSky02_StarsSprite },
          spriteConfig: {
            direction: SpriteDirection.Vertical,
            frameWidth: 320,
            frameHeight: 164,
            frameCount: 30,
            frameDurationMilliseconds: 50,
          },
        },
        {
          zIndex: 10,
          image: {
            src: TestBackgroundSky02_Cloud_01,
            width: 320,
            height: 250,
          },
        },
        {
          zIndex: 10,
          image: {
            src: TestBackgroundSky02_Cloud_02,
            width: 320,
            height: 250,
          },
        },
      ],
    },
  },

  sequence: [
    {
      pauseUntilFinished: true,
      addLayer: {
        text: {
          en: "Test",
          cz: "Test",
        },
      },
    },
    {
      pause: { durationSec: 1 },
    },
    {
      //pauseUntilFinished: true,
      animateBackground: {
        durationSec: 2,
        offsetY: GAME_CONFIG.scene.dimensions.y - 250,
      },
    },
    {
      pauseUntilFinished: true,
      addLayer: {
        zIndex: 1,
        image: { src: TestBackgroundSky02_BirdSprite },
        spriteConfig: {
          direction: SpriteDirection.Vertical,
          frameWidth: 320,
          frameHeight: 55,
          frameCount: 90,
          frameDurationMilliseconds: 40,
          originOffset: { x: 0, y: 117 },
          playCount: 1,
        },
      },
    },
    {
      //pauseUntilFinished: true,
      //hideAfterFinished: true,
      addLayer: {
        zIndex: 20,
        video: {
          src: TestBackgroundSky02_Video,
          width: 320,
          height: 250, // necessary for background transforms, otherwise the image is clipped to scene size
          playCount: 1,
          frameDurationMilliseconds: 40,
        },
      },
    },
    {
      pause: { durationSec: 5 },
    },
    {
      pauseUntilFinished: true,
      addLayer: {
        text: {
          en: "That was a background animation with video and overlaps.",
          cz: "To byla animace pozadí s videem a překrýváním.",
        },
      },
    },
  ],
};

export default TestCinematicScreen06;
